import {
  type ChatMessage,
  ChatMessageView,
} from '@features/chat/chat-container';
import { isOutgoingUserChatMessage } from '@lib/chat/adminChatRoom';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

interface ChatMessageListProps {
  messages: ChatMessage[];
  userId?: string | number;
  onRetry: (messageId: string) => void;
}

const ChatMessageList = ({
  messages,
  userId,
  onRetry,
}: ChatMessageListProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      {messages.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            minHeight: 220,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            px: 2.5,
            py: 3,
            textAlign: 'center',
            fontSize: '0.875rem',
            lineHeight: 1.5,
            color: 'text.secondary',
            '& strong': {
              mb: 0.5,
              display: 'block',
              fontSize: '0.95rem',
              color: 'text.primary',
            },
          }}
        >
          <strong>{t('chat.emptyTitle')}</strong>
          {t('chat.emptyHint')}
        </Box>
      ) : (
        messages.map((message, index) => (
          <ChatMessageView
            key={message.uuid || message._id || index}
            message={message}
            isOutgoing={isOutgoingUserChatMessage(message, userId)}
            onRetry={onRetry}
          />
        ))
      )}
    </>
  );
};

export default ChatMessageList;
